import { timeOptions } from 'data/timeOptions';
import { isEqual } from 'lodash';
import dateformat from 'dateformat';
import utils from 'utils';
import { t } from 'i18next';
import { ObjectValues } from 'types';

export const getYesterday = () => {
  const today = new Date();

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  return yesterday;
};

export const getDateAtStartOfTheDate = (date: Date | string) => {
  const tmpDate = new Date(date);

  const startOfDate = new Date(
    tmpDate.getFullYear(),
    tmpDate.getMonth(),
    tmpDate.getDate(),
  );

  return startOfDate;
};

export const getTimeOptionsAboveHour = (hour: number) =>
  timeOptions.filter(({ value }) => +value > hour);

export const getIsStartOfDayToday = (date: Date) =>
  isEqual(
    getDateAtStartOfTheDate(new Date()),
    getDateAtStartOfTheDate(new Date(date)),
  );

export const DATE_FORMAT_DEFAULT = 'dd mmm yyyy';
export const DATE_FORMAT_FULL = 'dd / mmmm / yyyy';
export const DATE_FORMAT_COMPACT = 'dd-mm-yy';
export const DATE_FORMAT_COMPACT_SLASH = 'dd/mm/yy';
export const DATE_FORMAT_COMPACT_WITH_FULL_YEAR_SLASH = 'dd/mm/yyyy';
export const DATE_FORMAT_WITH_FULL_MONTH = 'mmmm d, yyyy';
export const DATE_FORMAT_FULL_DATETIME = 'dd_mmm_yyyy_hh_MM_ss';
export const DATE_FORMAT_DAY_MONTH = 'dd mmmm';
export const DATE_FORMAT_SHORT_SLASH = 'd/mm/yy';
export const DATE_FORMAT_SHORT_SLASH_WITH_TIME = 'd/mm/yy h:MMtt';
export const TIME_FORMAT_MINUTES_SECONDS = 'MM:ss';
export const TIME_FORMAT_12H = 'hh:MM TT';
export const TIME_FORMAT_12H_COMPACT = 'h:MMtt';
export const TIME_FORMAT_12H_SHORT = 'HH:MM';
export const DATE_FORMAT_MONTH_DAY = 'mmm d';

export function getFormattedDate(date: Date, format = DATE_FORMAT_DEFAULT) {
  if (!date) return '';
  return dateformat(date, format);
}

export function getListingExpirationDate(
  expirationDate: Date | string,
  seekingExpressionOfInterestDate?: Date | string,
) {
  if (!expirationDate && !seekingExpressionOfInterestDate) return null;
  if (!seekingExpressionOfInterestDate) return new Date(expirationDate);
  if (!expirationDate) return new Date(seekingExpressionOfInterestDate);

  const exprDate = new Date(expirationDate);
  const seekingDate = new Date(seekingExpressionOfInterestDate);

  return seekingDate < exprDate ? seekingDate : exprDate;
}

export const isDateFromLastDays = (date: Date | string, days: number) => {
  const now = new Date();

  const daysAgoDate = new Date();
  const checkedDate = new Date(date);

  daysAgoDate.setDate(now.getDate() - days);

  return checkedDate >= daysAgoDate && checkedDate <= now;
};

export const isDateInNextDays = (date: Date | string, days: number) => {
  const now = new Date();

  const daysAheadDate = new Date();
  const checkedDate = new Date(date);

  daysAheadDate.setDate(now.getDate() + days);

  return checkedDate >= now && checkedDate <= daysAheadDate;
};

export const generateDaysLeftString = (date: Date | string) => {
  if (!date) return '';

  const { type, count } = utils.humanize(date);

  return t(type, { count });
};

export const TIMEFRAME = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_7_DAYS: 'last_7_days',
  LAST_30_DAYS: 'last_30_days',
  LAST_3_MONTHS: 'last_3_months',
  LAST_6_MONTHS: 'last_6_months',
  LAST_12_MONTHS: 'last_12_months',
  ALL: 'all',
} as const;

export type Timeframe = ObjectValues<typeof TIMEFRAME>;
